
export type EditorView = 'preview' | 'rich_text' | 'canvas' | 'table'
export type FilePresentation = { kind: 'markdown' | 'workflow' | 'structured'; defaultView: EditorView;
  views: { label: string; value: EditorView | 'source' }[] }
const SOURCE = { label: '源码', value: 'source' as const }
const PRESENTATIONS: Record<FilePresentation['kind'], FilePresentation> = {
  markdown: { kind: 'markdown', defaultView: 'preview', views: [
    { label: '预览', value: 'preview' }, { label: '可视编辑', value: 'rich_text' }, SOURCE] },
  workflow: { kind: 'workflow', defaultView: 'canvas', views: [{ label: '流程画布', value: 'canvas' }, SOURCE] },
  structured: { kind: 'structured', defaultView: 'table', views: [{ label: '表格编辑', value: 'table' }, SOURCE] },
}

/** Fixed native documents are direct entries. Custom collections remain collections, even with one file. */
export const FIXED_ENTRIES = new Set(['fields.yaml', 'workflow.yaml', 'README.md'])
export const CATEGORY_PRESENTATIONS = new Map([
  ['fields', { addFiles: false }], ['workflow', { addFiles: false }], ['documentation', { addFiles: false }],
])
export const categoryPresentation = (key: string) => CATEGORY_PRESENTATIONS.get(key) ?? { addFiles: true }

/** Technical view selection never chooses execution semantics or enables a capability. */
export const filePresentation = (path: string, content: string): FilePresentation => {
  void content // Native configuration contents never choose a business canvas.
  if (/\.md$/i.test(path)) return PRESENTATIONS.markdown
  return PRESENTATIONS.structured
}
